module.exports = __webpack_public_path__ + "img/dashboard_noaccount_clock.f095e71e.svg";